import { StrictAutocompleteOption } from '@savgroup-front-common/types';

interface AdaptReasonsToOptionsArgs<T> {
  reasons: T[];
}

const adaptReasonsToOptions = <T extends { id: string; label: string }>({
  reasons,
}: AdaptReasonsToOptionsArgs<T>): StrictAutocompleteOption<T>[] =>
  reasons.map((reason) => ({
    label: reason.label,
    value: reason.id,
    data: reason,
  }));

export default adaptReasonsToOptions;
